<template>
  <div class="matrix-select-choice">
    <q-table :view="view" :columns="issue.items" :rows="issue.rows" :row-desc="issue.rowDesc" :widths="issue.widths">
      <template v-slot:content="{ row, col }">
        <matrix-select-content :option="issue.getCellByRowAndCol(row, col)" />
      </template>
    </q-table>
  </div>
</template>

<script>
import MatrixTable from '@/questions/components/MatrixTable'
import MatrixSelectContent from '@/questions/components/MatrixSelectContent'
import QTable from '@/questions/components/QTable'

export default {
  name: 'MatrixSelectChoice',
  components: { QTable, MatrixSelectContent, MatrixTable },
  changeExpr: 'selectAllIds',
  computed: {
    selectAllIds() {
      return this.issue.options.map(item => item.value)
    }
  },
  created() {
    console.log('MatrixSelectChoice')
  }
}
</script>

<style scoped></style>
